const GTM_FROM_LS_RECORD = 'gtm_from_record';

export default GTM_FROM_LS_RECORD;
